import "./syncBinder.scss";

// import ImmutablePropTypes from "react-immutable-proptypes";
// import { PropTypeShapes } from "../../types";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

import FormButton from "../../components/form/FormButton";
import Icon from "../../components/interface/Icon";
import interfaceIdentifiers from "../../constants/interfaceIdentifiers";
import dialogs from "../../dialogs";
// import _ from "lodash";

class SyncBinderHeader extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      popoverOpen: false,
      saveName: null
    };
    this.togglePopover = this.togglePopover.bind(this);
    this.onSyncNowClick = this.onSyncNowClick.bind(this);
  }

  togglePopover() {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    });
  }

  onSyncNowClick() {
    if (this.props.showTrashWarning) {
      const msg =
        "Some documents will be moved into the Trash folder in your writing project.\n\nDo you wish to continue?";
      dialogs.okCancelPrompt(msg, result => {
        if (result) {
          this.props.onSyncClick();
        }
      });
    } else {
      this.props.onSyncClick();
    }
  }

  render() {
    return (
      <div>
        <div key="header" className="syncBinderHeader">
          <span>Sync</span>
          {this.props.syncNowEnabled ? (
            <FormButton
              label="Sync now"
              primary={true}
              onClick={this.onSyncNowClick}
              tooltip="Sync all changes now"
              pulse={this.props.pulsateIconId === interfaceIdentifiers.SYNC_PANEL_SYNC_NOW}
            />
          ) : null}
          <Icon
            color="iconMono"
            onClick={this.props.onSettingsClick}
            icon="sidebarSettings"
            tooltip="Open Sync Settings"
            pulse={this.props.pulsateIconId === interfaceIdentifiers.SYNC_PANEL_SETTINGS}
          />
        </div>
      </div>
    );
  }
}

SyncBinderHeader.propTypes = {
  showTrashWarning: PropTypes.bool,
  syncNowEnabled: PropTypes.bool,
  onSyncClick: PropTypes.func,
  onSettingsClick: PropTypes.func,
  pulsateIconId: PropTypes.string
};

export default SyncBinderHeader;
